module.exports = {"140929100":"岚漪镇","140929101":"三井镇","140929102":"宋家沟镇","140929201":"高家会乡","140929202":"李家沟乡","140929203":"水峪贯乡","140929204":"西豹峪乡","140929205":"温泉乡","140929206":"阳坪乡","140929207":"大涧乡","140929400":"岢岚县居民"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140929.json
// module id = 443
// module chunks = 0